import {ReactComponent} from "./ic_triangle_arrow_right.svg";

interface TriangleArrowRightIconProps {
    color?: string;
    size?: number;
}

const TriangleArrowRightIcon: React.FC<TriangleArrowRightIconProps> = (
    {
        color = '#09121F',
        size = 24,
    }
) => <ReactComponent
    style={{fill: color, width: size, height: size}}
/>;

export default TriangleArrowRightIcon;
